import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=02f32e98&scoped=true&"
import script from "./side-nav.vue?vue&type=script&lang=js&"
export * from "./side-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f32e98",
  null
  
)

export default component.exports